<div class="page-title-area">
    <div class="container">
      <div class="page-title-content">
        <h2>Cloud Based Software Development</h2>
        <ul>
          <li><a routerLink="/services">Services</a></li>
          <li>Cloud Based Software Development</li>
        </ul>
      </div>
    </div>
  </div>